import React, { useContext, useEffect, useRef } from "react";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";

const SaveAsScDicomButton = ({ viewportIndex, handleUploadScDicom }) => {
  const { activeViewportIndex } = useContext(ViewportContext);
  const handleUploadScDicomRef = useRef(handleUploadScDicom);
  handleUploadScDicomRef.current = handleUploadScDicom;

  // Shift+G keyboard shortcut → save viewport content as Secondary Capture DICOM
  useEffect(() => {
    if (viewportIndex !== activeViewportIndex) return;
    const onKeyDown = (e) => {
      if (!e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;
      if (e.key !== "g" && e.key !== "G") return;
      // Shift+G is a capital "G" while typing — never hijack text entry
      // (report editor, comment boxes, search fields).
      const target = e.target;
      if (
        target &&
        (target.nodeName === "INPUT" ||
          target.nodeName === "TEXTAREA" ||
          target.nodeName === "SELECT" ||
          target.isContentEditable)
      ) {
        return;
      }
      // Holding the keys down must not fire a burst of captures.
      if (e.repeat) return;
      e.preventDefault();
      e.stopPropagation();
      console.warn("::SC-SHORTCUT:: [SaveAsScDicomButton] Shift+G capture", { viewportIndex });
      handleUploadScDicomRef.current?.(viewportIndex);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [viewportIndex, activeViewportIndex]);

  return (
    <div>
      <span
    onClick={() => handleUploadScDicom(viewportIndex)}
      title="Save viewport content as Secondary Capture DICOM (Shift+G)"
    >
      <span className="secondary-capture-button"> </span>
    </span>
    </div>
  );
};

export default SaveAsScDicomButton;
